import { render, staticRenderFns } from "./myBorder2.vue?vue&type=template&id=31dc453e"
import script from "./myBorder2.vue?vue&type=script&lang=js"
export * from "./myBorder2.vue?vue&type=script&lang=js"
import style0 from "./myBorder2.vue?vue&type=style&index=0&id=31dc453e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports